import React, { useEffect, useState } from "react";
import { useSchedule } from "../../data/ScheduleContext";

export default function PopupBanner() {
	const [showPopup, setShowPopup] = useState(false);
	const { serverDate } = useSchedule();

	const getBannerImage = (date) => {
		if (!date) return null;

		// Aug 28 - Sep 6
		if (date >= "2026-08-28" && date <= "2026-09-06") {
			return "CASH_AND_CARD-DOUBLE-REWARDS-POPUP.webp";
		}

		// Sep 7 - Sep 18
		if (date >= "2026-09-07" && date <= "2026-09-18") {
			return "FASTSPIN-RACE_TO_FAME-POPUP.webp";
		}

		// No popup outside the scheduled dates
		return null;
	};

	const imageName = getBannerImage(serverDate);

	useEffect(() => {
		// Wait until serverDate is available
		if (!serverDate) {
			return;
		}

		// No scheduled banner for this date
		if (!imageName) {
			setShowPopup(false);
			return;
		}

		const isClosed = getCookie("popupBannerClosed");

		setShowPopup(!isClosed);
	}, [serverDate, imageName]);

	const handleClose = () => {
		const expires = getNextMidnight();

		document.cookie = `popupBannerClosed=true; expires=${expires.toUTCString()}; path=/`;

		setShowPopup(false);
	};

	if (!showPopup || !imageName) {
		return null;
	}

	return (
		<div className="fgh-popup-banner">
			<img src={`/images/banners/${imageName}`} alt="Promotion Banner" />

			<button type="button" onClick={handleClose}>
				CLOSE
			</button>
		</div>
	);
}

function getCookie(name) {
	const cookies = document.cookie.split("; ");

	const cookie = cookies.find((item) => item.startsWith(`${name}=`));

	return cookie ? cookie.split("=")[1] : null;
}

function getNextMidnight() {
	const tomorrow = new Date();

	tomorrow.setDate(tomorrow.getDate() + 1);
	tomorrow.setHours(0, 0, 0, 0);

	return tomorrow;
}
